import { useContext } from "react";
import { DarkModeContext } from "@/contexts/DarkModeContext/DarkModeContext";

export const useDarkModeContext = () => {
  const context = useContext(DarkModeContext);
  if (!context)
    throw new Error("Please use within bounds of Dark Mode Context Provider.");
  return context;
};
